import { notesStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaNotes";
import { css } from "styled-components";

notesStyles.wrapper = {};
notesStyles.notesTextArea = {
    cssOverrides: {
        inputSelect: css`
            resize: none;
        `,
    },
};
